export default __webpack_public_path__ + "static/media/fibonacci.7678607e.svg";